/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./styles.css";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

import TopBarProgress from "react-topbar-progress-indicator";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { CircularProgress, Pagination } from "@mui/material";
import moment from "moment";

import { ImAttachment } from "react-icons/im";

import OrderStatusButton from "../../order/components/OrderStatusButton";
import EditTabelDrawer from "../../../../components/Edit-tabel-drawer/EditTabelDrawer";
import ShowNotes from "../../order/components/ShowNotes";
import OrderDetails from "../../order/components/OrderDetails";
import { getAllPendingOrders } from "../../../../actions/order";
import CostsUpdateComp from "./components/CostsUpdateComp";
import CostBreakDown from "./components/CostBreakDown";
import RefundUpdateComp from "./components/RefundUpdateComp";
import SearchFilter from "../../../../components/CustomeFilter/SearchFilter";
import SelectSearchFilter from "../../../../components/CustomeFilter/SelectSearchFilter";
import AddNewNotes from "../../order/components/AddNewNotes";
import { Calculation } from "../../../../utils/Calculation";

import ClaimUpdateComp from "./components/ClaimUpdateComp";
import DashboardPagesLayout from "../../customerServiceDashboard/components/DashboardPagesLayout";
import DateRangeFilter from "../../../../components/CustomeFilter/DateRangeFilter";
import { MMDDYYFormat } from "../../../../utils/dateFormate";
import SelectMultipleFilter from "../../../../components/CustomeFilter/SelectMultipleFilter";
import {
  getClaimDisplayValue,
  getEditCostBodyContent,
  getEditCostStatus,
  getOrderClaimStatus,
} from "./utils";
import { fetchAllStores } from "../../../../reducers/storesSlice";

const SaleAnalysis = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderNumber = searchParams.get("orderNumber");
  const brand = searchParams.get("brand");

  const [loading, setloading] = useState(true);
  const [InnderLoader, setInnderLoader] = useState(false);

  const [IsMount, setIsMount] = useState(false);

  const [AllOrders, setAllOrders] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [Brand, setBrand] = useState(JSON.parse(localStorage.getItem("Brand")));

  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SelectItem, setSelectItem] = useState({});
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });
  // console.log("EditEdit==>", Edit)
  const initialSearchFilter = {
    OrderStatus: "",
    TrackingDetails: "",
    SearchByDate: "",
    SearchQuery: orderNumber ?? "",
    sort: "",
    shipandtrack: "",
    claims: "",
    deliverytype: "",
    brand: brand ?? "",
  };

  const [SearchFillter, setSearchFillter] = useState(initialSearchFilter);

  const resetFilters = () => {
    resetToFirstPage();
    setSearchFillter(initialSearchFilter);
  };


  const setDateToEmpty = (inputDate) => {
    return inputDate === "mm/dd/yy,mm/dd/yy" ? "" : inputDate;
  };

  // Api calls for get Order
  const getOrders = useCallback(
    async (
      pageNumber,
      searchQuery,
      status,
      date,
      tracking,
      sort,
      claims,
      deliverytype,
      brand,
      trackingStatus,
      shipandtrack
    ) => {
      setInnderLoader(true);
      try {
        date = setDateToEmpty(date);
        const res = await dispatch(
          getAllPendingOrders(
            pageNumber,
            searchQuery,
            status,
            date,
            tracking,
            sort,
            claims,
            deliverytype,
            "",
            "",
            "",
            brand,
            trackingStatus,
            shipandtrack
          )
        );

        if (res) {
          setAllOrders(res?.orders);

          // 🔥 Preserve drawer if open: re-select item by ID
          if (Edit.open && SelectItem?._id) {
            const newlySelected = res.orders.find(order => order._id === SelectItem._id);
            if (newlySelected) {
              setSelectItem(newlySelected);
            }
            // Keep drawer open
            // setEdit(prev => prev.open ? prev : { open: false, edit: "", title: "" });
          } else {
            // Only update SelectItem if drawer is closed
            setSelectItem(res?.orders?.[0] || {});
          }

          setpagination({ ...res.pagination });
        }
      } catch (error) {
        console.log("error message is : ", error);
      } finally {
        setloading(false);
        setInnderLoader(false);
      }
    },
    // ✅ Now safe: only depends on Edit and SelectItem (which are used)
    [Edit.open, SelectItem?._id]
  );

  useEffect(() => {
    var isSubscribe = true;
    // setloading(true);
    // setInnderLoader(true);
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getOrders(
          pagination?.currentPage,
          SearchFillter.SearchQuery,
          SearchFillter.OrderStatus,
          SearchFillter.SearchByDate,
          SearchFillter.TrackingDetails,
          SearchFillter.sort,
          SearchFillter.claims,
          SearchFillter.deliverytype,
          SearchFillter.brand,
          SearchFillter?.trackingStatus,
          SearchFillter?.shipandtrack
        );

        if (Brand) {
          dispatch(fetchAllStores());
        }
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination?.currentPage,
    SearchFillter.SearchQuery,
    SearchFillter.OrderStatus,
    SearchFillter.SearchByDate,
    SearchFillter.TrackingDetails,
    SearchFillter.sort,
    SearchFillter.claims,
    SearchFillter.deliverytype,
    SearchFillter.brand,
    SearchFillter?.trackingStatus,
    SearchFillter?.shipandtrack,

    IsMount,
    // Edit.open,
  ]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: "/admin/sale-analysis",
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: "/admin/sale-analysis",
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };


  const handleAction = (item, actionType) => {
    const editConfig = {
      Notes: { edit: "Notes", title: "Notes" },
      Costs: { edit: "editCosts", title: "Costs" },
      Refund: { edit: "refund", title: "Refunds" },
      Claim: { edit: "Claim", title: "Claim" },
    };

    const config = editConfig[actionType];

    if (config) {
      const newEdit = {
        open: true,
        edit: config.edit,
        title: config.title,
      };
      setEdit(newEdit);

      setSelectItem({ ...item });
    }
  };


  // console.log("AllOrders", AllOrders)

  const getTier = (value) => {
    const tierMap = {
      99: "Bronze",
      199: "Silver",
      299: "Gold",
    };

    return tierMap[value] || "Standard"; // Default to "Free" if no match is found
  };

  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div
            className=" d-flex  justify-content-end align-center"
            style={{ gap: "20px" }}
          >
            <SearchFilter
              width={"250px"}
              type="text"
              placeholder={"Search Order #, Tracking #"}
              value={SearchFillter?.SearchQuery}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchQuery: e.target.value,
                });
              }}

            />
            <DateRangeFilter
              title={"Order Date"}
              placeholder={"Select"}
              startDate={SearchFillter?.SearchByDate.split(",")[0]}
              endDate={SearchFillter?.SearchByDate.split(",")[1]}
              onChange={(Date) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchByDate: `${MMDDYYFormat(Date[0])},${MMDDYYFormat(
                    Date[1]
                  )}`,
                });
              }}

            />
            <SelectSearchFilter
              title={"Brand"}
              placeholder="Select"
              width={"200px"}
              value={
                SearchFillter?.brand
                  ? Brand.find((item) => SearchFillter?.brand === item?.id)
                    ?.value
                  : ""
              }
              options={Brand}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  brand:
                    value !== ""
                      ? Brand.find((item) => item.value === value)?.id
                      : "",
                });
              }}

            />

            <SelectMultipleFilter
              width={"200px"}
              title={"Order Status"}
              placeholder="All"
              value={[]}
              options={[
                { value: "Pending", label: "Pending" },
                { value: "Processing", label: "Processing" },
                { value: "Preparing To Ship", label: "Preparing To Ship" },
                { value: "In Transit", label: "In Transit" },
                { value: "Delivered", label: "Delivered" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, trackingStatus: value });
              }}

            />
            <SelectSearchFilter
              title={"Shipping & Tracking"}
              placeholder="Select"
              value={SearchFillter?.shipandtrack}
              options={[
                { value: "notProvided", label: "+Add" },
                { value: "provided", label: "included" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, shipandtrack: value });
              }}

            />
            <SelectSearchFilter
              title={"Sort"}
              placeholder="Select"
              value={SearchFillter?.sort}
              options={[
                { value: "desc", label: "Newest First" },
                { value: "asc", label: "Oldest First" },
              ]}
              onChange={(value) => {
                resetToFirstPage();
                setSearchFillter({ ...SearchFillter, sort: value });
              }}

            />

            <button
              onClick={resetFilters}
              className="reset-filter-button search-filter "
            >
              Reset Filters
            </button>
          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Sale Analysis"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="process-orders-table">
                <table className="m-0">
                  <thead>
                    <tr>
                      <th>Order#</th>
                      <th>Order Status</th>
                      <th>Order Date</th>
                      <th>Brand</th>
                      <th>Qty</th>
                      <th style={{ padding: "0 5px" }}>Stocks</th>
                      <th>COGS</th>
                      <th>Ship Type</th>
                      <th>Ship Cost</th>
                      <th>
                        Priority <br /> Protection
                      </th>
                      <th>
                        DS <br /> Fees
                      </th>
                      <th>Subtotal</th>
                      <th>Total</th>
                      <th>Profit</th>
                      <th>Refund</th>
                      <th>Claim</th>
                      <th>Edit Costs</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {AllOrders?.length ? (
                      <>
                        {AllOrders?.map((order, i) => (
                          <tr key={order?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${order?._id}`)
                              }
                            >
                              {order?.itemOrderNumber}
                            </td>
                            <td>
                              <span>
                                <OrderStatusButton
                                  width={250}
                                  status={order.trackingStatus}
                                // status={"Returned"}
                                >
                                  {order.trackingStatus}{" "}
                                  {order.trackingStatus === "Backordered"
                                    ? `(${order?.backorderStatus?.status
                                      ? order?.backorderStatus?.status
                                      : "Pending"
                                    })`
                                    : null}
                                </OrderStatusButton>
                              </span>
                            </td>
                            <td>{moment(order?.createdAt).format("L")}</td>
                            <td>{order?.brandId?.fullName.split(" ")[0] || order?.manufacturer}</td>
                            {/* {console.log("order", order)} */}
                            <td>{order?.quantity}</td>
                            <td style={{ color: order?.productId?.quantity < 6 ? 'red' : 'inherit', fontWeight: order?.productId?.quantity < 6 ? 'bold' : 'normal' }}>
                              {order?.productId?.quantity}
                            </td>
                            <td
                              style={
                                order?.orCogs?.type === "promo"
                                  ? { color: "#17a858" }
                                  : order?.costType === "promo"
                                    ? { color: "#17a858" }
                                    : {}
                              }
                            >
                              ${Calculation(order, "COGS")}
                            </td>
                            <td>
                              <span
                                style={
                                  order?.orShipping?.shippingFee === 299 ||
                                    order?.shippingFee === 299
                                    ? {}
                                    : { color: "#878787" }
                                }
                              >
                                {`${order?.orShipping?.type
                                  ? order?.orShipping?.type
                                  : getTier(order?.shippingFee)
                                  }`}
                              </span>
                            </td>
                            <td>${Calculation(order, "shippingTotal")}</td>
                            <td>${order?.shippingProtectionFee?.toFixed(2)}</td>
                            <td>${Calculation(order, "dsFee")}</td>

                            <td>{Calculation(order, "OrderSubTotal")}</td>
                            <td>${Calculation(order, "OrderTotal")}</td>
                            <td>${Calculation(order, "profit")}</td>
                            <td>
                              <span
                                onClick={() => handleAction(order, "Refund")}
                              >
                                <OrderStatusButton
                                  width={100}
                                  status={
                                    order?.refunds?.status ? "Returned" : "+add"
                                  }
                                >
                                  {order?.refunds?.itemPrice
                                    ? `$${order?.refunds?.itemPrice}`
                                    : "+ Add"}
                                </OrderStatusButton>
                              </span>
                            </td>

                            <td>
                              <span
                                onClick={() => handleAction(order, "Claim")}
                              >
                                <OrderStatusButton
                                  width={100}
                                  status={getOrderClaimStatus(
                                    order?.claims?.claimStatus
                                  )}
                                >
                                  {getClaimDisplayValue(order)}
                                </OrderStatusButton>
                              </span>
                            </td>
                            {/* Edit Cost */}
                            <td>
                              <div onClick={() => handleAction(order, "Costs")}>
                                <OrderStatusButton
                                  width={150}
                                  status={getEditCostStatus(order)}
                                >
                                  {getEditCostBodyContent(order)}
                                </OrderStatusButton>
                              </div>
                            </td>

                            <td>
                              <div onClick={() => handleAction(order, "Notes")}>
                                <OrderStatusButton
                                  width={90}
                                  status={
                                    order?.notes?.length ? "In Transit" : "+add"
                                  }
                                >
                                  <span>
                                    <ImAttachment
                                      style={{
                                        fontSize: "20px",
                                      }}
                                    />
                                  </span>
                                  <span className="ml-2">
                                    {order?.notes?.length}
                                  </span>
                                </OrderStatusButton>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={16} className=" text-center">
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <EditTabelDrawer
                  Edit={Edit}
                  setEdit={setEdit}
                  shippingId={SelectItem?.itemOrderNumber}
                >
                  {InnderLoader ? (
                    <div className="d-flex align-center justify-content-center">
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {Edit.edit === "editCosts" && (
                        <>
                          <CostsUpdateComp
                            SelectItem={SelectItem}
                            IsMount={IsMount}
                            setIsMount={setIsMount}
                          />
                          <CostBreakDown SelectItem={SelectItem} />
                          <ShowNotes
                            title="Cost Notes"
                            notes={SelectItem?.notes?.filter(
                              (message) => message.subject === "Costs"
                            )}
                          />
                        </>
                      )}

                      {Edit.edit === "Claim" && (
                        <>
                          <ClaimUpdateComp
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                          />
                          <hr />
                          <ShowNotes
                            title="Claim Notes"
                            notes={SelectItem?.notes?.filter(
                              (message) => message.subject === "Claim"
                            )}
                          />
                          <hr />

                          <AddNewNotes
                            SelectItem={SelectItem}
                            setEdit={setEdit}
                            setAllOrders={setAllOrders}
                          />
                        </>
                      )}

                      {Edit.edit === "refund" && (
                        <>
                          <RefundUpdateComp
                            setEdit={setEdit}
                            SelectItem={SelectItem}
                          />
                          <hr />
                          <ShowNotes
                            title="Refund Notes"
                            SelectItem={SelectItem}
                            notes={SelectItem?.notes?.filter(
                              (message) => message.subject === "Refunds"
                            )}
                          />
                          <hr />

                          <AddNewNotes
                            SelectItem={SelectItem}
                            setEdit={setEdit}
                            setAllOrders={setAllOrders}
                          />
                        </>
                      )}
                      {Edit.edit === "Notes" && (
                        <>
                          <AddNewNotes
                            SelectItem={SelectItem}
                            setEdit={setEdit}
                            setAllOrders={setAllOrders}
                          />
                          <ShowNotes
                            title="All Notes"
                            SelectItem={SelectItem}
                            notes={SelectItem?.notes}
                          />
                        </>
                      )}

                      <hr className=" mb-0" />
                      <OrderDetails
                        IsMount={IsMount}
                        setIsMount={setIsMount}
                        setEdit={setEdit}
                        SelectItem={SelectItem}
                      />
                    </>
                  )}
                </EditTabelDrawer>
              </div>

              <div className="d-flex justify-content-center align-center p-2">
                <div className=" mx-auto">
                  <Pagination
                    count={pagination.totalPages}
                    page={pagination.currentPage}
                    onChange={handleChange}
                  />
                </div>

                <span className="font-weight-bold" style={{ color: "#9f9f9f" }}>
                  {AllOrders?.length} of {pagination?.count} Items
                </span>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default SaleAnalysis;
